import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { getAbsenceCategoryTranslationKey } from "@msuite/utils/absences";
import { getColorByString } from "@msuite/utils/colors";
import { moment } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import type { Substitution } from "@msuite/utils/types";
import { createTypeMenuOptions } from "./create-type-menu-options";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<Substitution>();

export const columns = [
	columnHelper.accessor((row) => moment(row.startDate).dateFormat(), {
		id: "startDate",
		header: localized("dates.start_date"),
		cell: (cell) => cell.getValue(),
		size: 200,
	}),
	columnHelper.accessor((row) => moment(row.endDate).dateFormat(), {
		id: "endDate",
		header: localized("dates.end_date"),
		cell: (cell) => cell.getValue(),
		size: 200,
	}),
	columnHelper.accessor((row) => localized(getAbsenceCategoryTranslationKey(row.category)), {
		id: "type",
		header: localized("general.type"),
		cell: (cell) => (
			<Tag
				variant="plain"
				color={getColorByString(cell.row.original.category)}
			>
				{cell.getValue()}
			</Tag>
		),
		meta: createMeta({
			menuOptions: createTypeMenuOptions,
		}),
	}),
	columnHelper.accessor("consumedDays", {
		id: "consumedDays",
		header: localized("absences.vacation_days"),
		cell: (cell) => formatNumber(cell.getValue(), "day"),
	}),
	createRowActions(RowActions),
];
